import { useMemo } from 'react';
import useWidgetContext from '../react/useWidgetContext';
import { getDimensionalCustomerStorage } from '../../../../common/service/customerStorage';

const useCustomerStorage = () => {
  const {
    configuration: { dimensions },
  } = useWidgetContext();

  return {
    customerStorage: useMemo(() => {
      return getDimensionalCustomerStorage(dimensions);
    }, [dimensions]),
  };
};

export default useCustomerStorage;
